import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'
import TimePicker from '../../common/TimePicker'

import * as configActions from '../../actions/Config'
import * as bookingSystemActions from '../../actions/BookingSystems'
import * as Strings from './strings'

class CreateBookingSystemModal extends Component {
  state = {
    errorMessage: '',
    nameInput: '',
    nameError: '',
    firstTimeInput: '',
    firstTimeError: '',
    lengthOfTimesInput: '',
    lengthOfTimeError: '',
    amountOfTimesInput: '',
    amountOfTimesError: ''
  }

  componentWillReceiveProps(nextProps) {
    const { bookingSystems } = this.props
    const { nameInput } = this.state

    if (
      !nextProps.bookingSystems.isCreating &&
      nextProps.bookingSystems.errorCreating === null &&
      bookingSystems.isCreating
    ) {
      this.props.hideCreateBookingSystemModal()
      this.props.showSnackbar(nameInput + ' ' + Strings.default.CREATED)
      this.resetFields()
    } else if (
      !nextProps.bookingSystems.isCreating &&
      nextProps.bookingSystems.errorCreating !== null &&
      bookingSystems.isCreating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  create() {
    const {
      nameInput,
      firstTimeInput,
      lengthOfTimesInput,
      amountOfTimesInput
    } = this.state
    const { data, user } = this.props

    this.setState({ errorMessage: '' })

    if (nameInput === '') {
      this.setState({ nameError: Strings.default.MANDATORY_FIELD })
    }

    if (firstTimeInput === '') {
      this.setState({ firstTimeError: Strings.default.MANDATORY_FIELD })
    }

    if (lengthOfTimesInput === '') {
      this.setState({ lengthOfTimeError: Strings.default.MANDATORY_FIELD })
    }

    if (amountOfTimesInput === '') {
      this.setState({ amountOfTimesError: Strings.default.MANDATORY_FIELD })
    }

    if (
      nameInput !== '' &&
      firstTimeInput !== '' &&
      lengthOfTimesInput !== '' &&
      amountOfTimesInput !== ''
    ) {
      const times = this.calculateTimes()
      const communityIds = [data.community.id]
      const object = {
        name: nameInput,
        maxBookings: 0,
        bookingRange: 0
      }
      const postData = { object, times, communityIds }

      this.props.tryCreateBookingSystem(
        user.token,
        postData,
        data.community.id
      )
    }
  }

  calculateTimes() {
    const {
      firstTimeInput,
      lengthOfTimesInput,
      amountOfTimesInput
    } = this.state
    const firstTimeSplit = firstTimeInput.split(':')
    const lengthOfTimesSplit = lengthOfTimesInput.split(':')
    const times = []

    if (lengthOfTimesSplit.length === 2 && firstTimeSplit.length === 2) {
      let lastTime = firstTimeSplit
      for (let i = 0; i < amountOfTimesInput; i++) {
        let endTime = [
          parseInt(lastTime[0], 10) + parseInt(lengthOfTimesSplit[0], 10),
          parseInt(lastTime[1], 10) + parseInt(lengthOfTimesSplit[1], 10)
        ]

        if (
          parseInt(lastTime[1], 10) + parseInt(lengthOfTimesSplit[1], 10) >
          59
        ) {
          endTime = [
            parseInt(lastTime[0], 10) + parseInt(lengthOfTimesSplit[0], 10) + 1,
            (parseInt(lastTime[1], 10) + parseInt(lengthOfTimesSplit[1], 10)) %
              60
          ]
        }

        if (endTime[0] > 23) {
          break
        }

        endTime[0] = this.fill(endTime[0])
        endTime[1] = this.fill(endTime[1])

        times.push({
          start: lastTime[0] + ':' + lastTime[1],
          end: endTime[0] + ':' + endTime[1]
        })

        lastTime = endTime
      }
    }

    return times
  }

  fill(time) {
    if (parseInt(time, 10) === 0) {
      return '00'
    } else if (time.toString().length === 1) {
      return '0' + time
    }

    return time
  }

  resetFields() {
    this.setState({
      errorMessage: '',
      nameInput: '',
      nameError: '',
      firstTimeInput: '',
      firstTimeError: '',
      lengthOfTimesInput: '',
      lengthOfTimeError: '',
      amountOfTimesInput: '',
      amountOfTimesError: ''
    })
  }

  render() {
    const {
      errorMessage,
      nameInput,
      nameError,
      firstTimeInput,
      firstTimeError,
      lengthOfTimesInput,
      lengthOfTimeError,
      amountOfTimesInput,
      amountOfTimesError
    } = this.state
    const { config, classes, bookingSystems } = this.props

    return (
      <Dialog
        open={config.createBookingSystemModal.show}
        aria-labelledby={'form-dialog-title'}
      >
        <DialogTitle id={'form-dialog-title'}>
          {Strings.default.CREATE_BOOKABLE_SYSTEM}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Strings.default.CREATE_BOOKABLE_SYSTEM_INFO}
          </DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <Input
            placeholder={Strings.default.TITLE}
            value={nameInput}
            onChange={text =>
              this.setState({
                nameInput: text,
                nameError: '',
                errorMessage: ''
              })
            }
            error={nameError}
          />
          <TimePicker
            placeholder={Strings.default.FIRST_TIME}
            value={firstTimeInput}
            onChange={text =>
              this.setState({
                firstTimeInput: text,
                firstTimeError: '',
                errorMessage: ''
              })
            }
            error={firstTimeError}
          />
          <TimePicker
            placeholder={Strings.default.LENGTH_OF_TIME}
            value={lengthOfTimesInput}
            onChange={text =>
              this.setState({
                lengthOfTimesInput: text,
                lengthOfTimeError: '',
                errorMessage: ''
              })
            }
            error={lengthOfTimeError}
          />
          <Input
            placeholder={Strings.default.NUMBER_OF_TIMES}
            type={'number'}
            value={amountOfTimesInput}
            onChange={text =>
              this.setState({
                amountOfTimesInput: text,
                amountOfTimesError: '',
                errorMessage: ''
              })
            }
            error={amountOfTimesError}
          />
        </DialogContent>
        {bookingSystems.isCreating ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => {
                this.props.hideCreateBookingSystemModal()
                this.resetFields()
              }}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => this.create()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

function mapStateToProps({ data, user, config, bookingSystems }) {
  return { data, user, config, bookingSystems }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CreateBookingSystemModal)



// WEBPACK FOOTER //
// ./src/components/containers/CreateBookingSystemModal/index.js